var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcMarker(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "32px",
    height: "53px",
    viewBox: "0 0 32 53",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Payment",
    transform: "translate(-711.000000, -547.000000)",
    fill: "#146E6E"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-17",
    transform: "translate(711.000000, 547.000000)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    strokeOpacity: 0.113008086,
    stroke: "#146E6E",
    strokeWidth: 2,
    cx: 16,
    cy: 49,
    r: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.9988699,24 C11.5688657,24 8,20.4067797 8,16 C8,11.5706215 11.5688657,8 15.9988699,8 C20.4062721,8 24,11.5706215 24,16 C24,20.4067797 20.4062721,24 15.9988699,24 M16,1.13686838e-13 C7.19432624,1.13686838e-13 0,7.08191489 0,15.75 C0,25.9595745 11.4836879,37.5765957 13.778156,39.8106383 L16.0476596,42 L18.2695035,39.7905319 C23.3985816,34.6745745 32,24.7531915 32,15.75 C32,7.08191489 24.8306383,1.13686838e-13 16,1.13686838e-13",
    id: "Fill-1-Copy-3"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcMarker);
export default __webpack_public_path__ + "static/media/ic_marker.dc9dd724.svg";
export { ForwardRef as ReactComponent };